import { supabase } from "../../createClient";
import * as Sentry from "@sentry/react";

type DuplicateFolderResponse = {
  success: boolean;
  error?: string;
};

export const duplicateFolderInStorage = async (
  sourceBucketName: string,
  sourceFolder: string,
  targetBucketName: string,
  targetFolder: string,
): Promise<DuplicateFolderResponse> => {
  try {
    const { data: files, error: listError } = await supabase.storage.from(sourceBucketName).list(sourceFolder);

    if (listError) {
      throw new Error(`Error listing files: ${listError.message}`);
    }

    if (!files || files.length === 0) {
      return { success: true };
    }

    for (const file of files) {
      if (file.name) {
        const sourceFilePath = `${sourceFolder}/${file.name}`;
        const targetFilePath = `${targetFolder}/${file.name}`;

        const { data: fileContent, error: downloadError } = await supabase.storage
          .from(sourceBucketName)
          .download(sourceFilePath);

        if (downloadError) {
          throw new Error(`Error downloading file ${sourceFilePath}: ${downloadError.message}`);
        }

        const { error: uploadError } = await supabase.storage
          .from(targetBucketName)
          .upload(targetFilePath, fileContent);

        if (uploadError) {
          throw new Error(`Error uploading file to ${targetFilePath}: ${uploadError.message}`);
        }
      }
    }

    return { success: true };
  } catch (error: any) {
    Sentry.captureException(error);
    return { success: false, error: error.message };
  }
};
